<h2 class="header-major">Create A New Template</h2>
<app-thought-form
  [thought]="template"
  isTemplateForm="true"
  (templateSaved)="templateSaved($event)"
  (templateCancelled)="templateCancelled($event)"
  (templateDeleted)="templateDeleted($event)"></app-thought-form>
